(function(){
var CALM=matchMedia('(prefers-reduced-motion: reduce)').matches;
/* Pop-up: wächst aus dem Ursprungselement und blendet ein, schließt zurück dorthin */
function Pop(root,origin,cls,label,fill,after){
  var m=document.createElement('div'),pan=document.createElement('div'),live=true,an=null;
  m.className='pqc-modal';m.setAttribute('role','dialog');m.setAttribute('aria-modal','true');m.setAttribute('aria-label',label);
  pan.className='pqc-panel '+cls;m.appendChild(pan);fill(pan);root.appendChild(m);
  document.documentElement.classList.add('pqc-lock');
  function from(){var a=origin.getBoundingClientRect(),b=pan.getBoundingClientRect();
    return 'translate('+((a.left+a.width/2)-(b.left+b.width/2))*.6+'px,'+((a.top+a.height/2)-(b.top+b.height/2))*.6+'px) scale('+Math.max(Math.min(a.width/b.width,1),.6)+')'}
  function run(open){if(an)an.cancel();if(CALM||!pan.animate)return an=null;
    var k=[{transform:from(),opacity:0},{transform:'none',opacity:1}];if(!open)k.reverse();
    return an=pan.animate(k,{duration:open?420:260,easing:open?'cubic-bezier(.2,.8,.2,1)':'cubic-bezier(.4,0,1,1)',fill:'both'})}
  void m.offsetWidth;m.classList.add('on');run(true);
  function key(e){if(e.key==='Escape')close()}
  function close(){if(!live)return;live=false;removeEventListener('keydown',key);
    m.classList.remove('on');var a=run(false);
    var done=function(){if(!m.parentNode)return;if(after)after();m.remove();
      if(!document.querySelector('.pqc-modal'))document.documentElement.classList.remove('pqc-lock')};
    if(a)a.finished.then(done,done);setTimeout(done,450)}
  m.addEventListener('click',function(e){if(e.target===m)close()});addEventListener('keydown',key);
  return {close:close,isOpen:function(){return live}};
}
var XSVG='<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

/* Vergleich */
document.querySelectorAll('.pqc').forEach(function(w){
  var dataEl=w.querySelector('.pqc-data');if(!dataEl)return;var D;try{D=JSON.parse(dataEl.textContent)}catch(e){return}
  var me=D[w.dataset.me],inn=w.querySelector('.pqc-in'),sel=w.querySelector('select'),tb=w.querySelector('tbody'),tbl=w.querySelector('.pqc-t'),o=w.querySelector('.pqc-other'),al=w.querySelector('.pqc-all');
  var Y='<svg class="ic y" viewBox="0 0 24 24" role="img" aria-label="'+((window.CC_I18N||{}).yes||'ja')+'"><circle cx="12" cy="12" r="9"/><path d="M8 12l3 3 5-6"/></svg>';
  var X='<svg class="ic x" viewBox="0 0 24 24" role="img" aria-label="'+((window.CC_I18N||{}).no||'nein')+'"><path d="M7 12h10"/></svg>';
  var cell=function(v){return v===true?Y:v===false?X:(v==null||v==='')?'<span class="na">'+((window.CC_I18N||{}).na||'k. A.')+'</span>':String(v).replace(/</g,'&lt;')};
  var body=inn.querySelector('.pqc-body'),openB=inn.querySelector('.pqc-open'),xB=inn.querySelector('.pqc-x'),pop=null;
  function fit(){if(pop)return;w.classList.toggle('cut',body.scrollHeight>body.clientHeight+4)}
  function draw(h){var ot=D[h];if(!ot)return;tb.style.opacity=.3;
    setTimeout(function(){var g=null,any=false;
      tb.querySelectorAll('tr').forEach(function(tr){
        if(tr.classList.contains('g')){if(g)g.className='g '+(any?'diff':'same');g=tr;any=false;return}
        var k=tr.dataset.k,a=me.v[k],b=ot.v[k],same=String(a)===String(b);if(!same)any=true;
        tr.className='r '+(same?'same':'diff');tr.querySelector('td.ot').innerHTML=cell(b)});
      if(g)g.className='g '+(any?'diff':'same');
      o.href=ot.u;var im=o.querySelector('img');if(im){im.src=ot.i;im.removeAttribute('srcset');im.alt=ot.n}
      o.querySelector('b').textContent=ot.n;o.querySelector('small').textContent=ot.p;
      if(al)al.href=al.href.split('?')[0]+'?m='+w.dataset.me+','+h;
      tb.style.opacity=1;fit()},150)}
  sel.addEventListener('change',function(){draw(sel.value)});
  inn.querySelector('.pqc-only').addEventListener('change',function(e){tbl.classList.toggle('all-rows',!e.target.checked);fit()});
  addEventListener('resize',fit);fit();
  openB.addEventListener('click',function(){if(pop)return;
    w.style.minHeight=w.offsetHeight+'px';
    pop=Pop(w.closest('.pq5')||document.body,w,'',((window.CC_I18N||{}).compare||'Vergleich'),function(p){p.appendChild(inn)},function(){
      w.appendChild(inn);w.style.minHeight='';xB.hidden=true;pop=null;fit();openB.focus({preventScroll:true})});
    xB.hidden=false;xB.focus({preventScroll:true})});
  xB.addEventListener('click',function(){if(pop)pop.close()});
});

/* App: Handy öffnet den Store, Desktop zeigt QR-Codes */
document.querySelectorAll('.pq5 [data-app-get]').forEach(function(b){
  var root=b.closest('.pq5'),d=b.dataset,ua=navigator.userAgent||'';
  b.addEventListener('click',function(){
    if(/iPhone|iPad|iPod/i.test(ua)&&d.ios){location.href=d.ios;return}
    if(/Android/i.test(ua)&&d.android){location.href=d.android;return}
    var pop=Pop(root,b,'qr',d.name||'App',function(p){
      p.innerHTML='<div class="pqc-top"><p class="lbl" style="margin:0">'+((window.CC_I18N||{}).app_get_html||'App <b>laden</b>')+'</p><button type="button" class="pqc-x" aria-label="'+((window.CC_I18N||{}).close||'Schließen')+'">'+XSVG+'</button></div><div class="qrb"><h3></h3><p></p><div class="qrs"></div></div>';
      var qb=p.querySelector('.qrb'),qs=p.querySelector('.qrs');
      if(d.icon){var ic=document.createElement('img');ic.className='qri';ic.src=d.icon;ic.alt='';ic.width=72;ic.height=72;qb.insertBefore(ic,qb.firstChild)}
      qb.querySelector('h3').textContent=d.name||'';
      qb.querySelector('p').textContent=(d.text?d.text+'. ':'')+((window.CC_I18N||{}).scan_qr||'QR-Code mit dem Handy scannen.');
      [['ios','qrIos','App Store'],['android','qrAndroid','Google Play']].forEach(function(x){if(!d[x[0]])return;
        var a=document.createElement('a');a.href=d[x[0]];a.target='_blank';a.rel='noopener';
        if(d[x[1]]){var im=document.createElement('img');im.src=d[x[1]];im.alt='QR '+x[2];im.width=150;im.height=150;a.appendChild(im)}
        var sp=document.createElement('span');sp.textContent=x[2];a.appendChild(sp);qs.appendChild(a)});
      p.querySelector('.pqc-x').addEventListener('click',function(){pop.close()});
      setTimeout(function(){p.querySelector('.pqc-x').focus({preventScroll:true})},0);
    });
  });
});

/* FAQ: alle Fragen im Pop-up, in der Kachel bleibt es kompakt */
document.querySelectorAll('.pq5 [data-faq]').forEach(function(b){
  var root=b.closest('.pq5'),src=root&&root.querySelector('.t4 .fq');if(!src)return;
  b.addEventListener('click',function(){var pop;
    pop=Pop(root,b,'txt',((window.CC_I18N||{}).faq||'Häufige Fragen'),function(p){
      p.innerHTML='<div class="pqc-top"><p class="lbl" style="margin:0">'+((window.CC_I18N||{}).faq_html||'Häufige <b>Fragen</b>')+'</p><button type="button" class="pqc-x" aria-label="'+((window.CC_I18N||{}).close||'Schließen')+'">'+XSVG+'</button></div><div class="fq"></div>';
      var box=p.querySelector('.fq');box.innerHTML=src.innerHTML;
      box.querySelectorAll('details').forEach(function(d){d.open=true});
      p.querySelector('.pqc-x').addEventListener('click',function(){pop.close()});
      setTimeout(function(){p.querySelector('.pqc-x').focus({preventScroll:true})},0);
    });
  });
});

/* Beschreibung: Knöpfe mit data-desc (untere Leiste, Technische Daten) */
document.querySelectorAll('.pq5 [data-desc]').forEach(function(b){
  var root=b.closest('.pq5'),src=root&&root.querySelector('.desc-body');if(!src)return;
  b.addEventListener('click',function(){var pop;
    pop=Pop(root,b,'txt',((window.CC_I18N||{}).description||'Beschreibung'),function(p){
      p.innerHTML='<div class="pqc-top"><p class="lbl" style="margin:0">'+((window.CC_I18N||{}).about||'Über den')+' <b></b></p><button type="button" class="pqc-x" aria-label="'+((window.CC_I18N||{}).close||'Schließen')+'">'+XSVG+'</button></div><div class="pqd"></div>';
      p.querySelector('.lbl b').textContent=b.dataset.title||'';
      p.querySelector('.pqd').innerHTML=src.innerHTML;
      p.querySelector('.pqc-x').addEventListener('click',function(){pop.close()});
      setTimeout(function(){p.querySelector('.pqc-x').focus({preventScroll:true})},0);
    });
  });
});
})();

/* Galerie: Pfeile und Tastatur (links/rechts), blättert über die Vorschaubilder */
(function(){
  var st=document.querySelector('.pq5 .stage'),tb=[].slice.call(document.querySelectorAll('.pq5 .thumbs button'));
  if(!st||tb.length<2)return;
  var AR={prev:[((window.CC_I18N||{}).prev_image||'Vorheriges Bild'),'M15 6l-6 6 6 6'],next:[((window.CC_I18N||{}).next_image||'Nächstes Bild'),'M9 6l6 6-6 6']};
  function go(d){var i=-1;tb.forEach(function(b,j){if(b.classList.contains('on'))i=j});
    var n=tb[(i+d+tb.length)%tb.length],c=n.parentNode;n.click();
    var cr=c.getBoundingClientRect(),nr=n.getBoundingClientRect();
    c.scrollTo({left:c.scrollLeft+(nr.left-cr.left)-(c.clientWidth-nr.width)/2,behavior:'smooth'})}
  Object.keys(AR).forEach(function(k){var b=document.createElement('button');b.type='button';b.className='g-nav '+k;b.setAttribute('aria-label',AR[k][0]);
    b.innerHTML='<svg class="ic" viewBox="0 0 24 24" aria-hidden="true"><path d="'+AR[k][1]+'"/></svg>';
    b.addEventListener('click',function(){go(k==='next'?1:-1)});st.appendChild(b)});
  /* Wischen auf dem Bild: nur waagerechte Gesten, senkrecht bleibt Seitenscroll */
  var x0=null,y0=0;
  st.addEventListener('touchstart',function(e){if(e.touches.length!==1){x0=null;return}x0=e.touches[0].clientX;y0=e.touches[0].clientY},{passive:true});
  st.addEventListener('touchend',function(e){if(x0==null)return;var t=e.changedTouches[0],dx=t.clientX-x0,dy=t.clientY-y0;x0=null;
    if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.5)go(dx<0?1:-1)},{passive:true});
  var vis=false;new IntersectionObserver(function(es){vis=es[0].isIntersecting}).observe(st);
  addEventListener('keydown',function(e){
    if(e.key!=='ArrowLeft'&&e.key!=='ArrowRight')return;
    if(!vis||e.altKey||e.ctrlKey||e.metaKey||e.shiftKey)return;
    var t=e.target;if(t&&(/^(INPUT|SELECT|TEXTAREA)$/.test(t.tagName)||t.isContentEditable))return;
    if(document.querySelector('.pqc-modal,.pq5 .sv.open'))return;
    e.preventDefault();go(e.key==='ArrowRight'?1:-1)});
})();

/* App-Video: lädt und spielt nur, wenn sichtbar */
(function(){
  var vs=document.querySelectorAll('.pq5 .phone video[data-src]');if(!vs.length||!('IntersectionObserver' in window))return;
  var calm=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;
    if(e.isIntersecting){if(!v.getAttribute('src')){v.preload=calm?'metadata':'auto';v.src=v.dataset.src}if(!calm)v.play().catch(function(){})}
    else if(v.getAttribute('src'))v.pause()})},{threshold:.2});
  vs.forEach(function(v){io.observe(v)});
})();
